import type { ButtonHTMLAttributes } from 'react';

import styles from './ui.module.css';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'primary' | 'danger';
}

/** The single button style of the application. */
export function Button({
  variant = 'default',
  className,
  type = 'button',
  ...rest
}: ButtonProps): React.JSX.Element {
  const classes = [styles.button, variant === 'default' ? '' : styles[variant], className]
    .filter(Boolean)
    .join(' ');

  return <button className={classes} type={type} {...rest} />;
}
